"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledErrorYear = exports.StyleInputDateYear = exports.StyleInputDate = exports.StyleWrapperInputDate = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyleWrapperInputDate = styled_components_1.default.div `
  display: flex;
  align-items: center;
  height: 30px;
  padding-left: 12px;
  width: calc(100% - 34px);

  & > input {
    appearance: none;
    border: none;
    font-family: Gotham A, Gotham B;
    font-size: 14px;
    letter-spacing: 1px;
    padding: 0;
    text-align: center;
    width: auto;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      appearance: none;
      margin: 0;
    }
    /* Firefox */
    &: [type= "number" ] {
      -moz-appearance: textfield;
    }

    &:focus-visible,
    &:focus,
    &:focus-within {
      outline-color: ${({ theme }) => theme.primary.lighter};
    }
  }
`;
exports.StyleInputDate = styled_components_1.default.input `
  max-width: 19px;
`;
exports.StyleInputDateYear = styled_components_1.default.input `
  max-width: 50px;
  width: 42px
  text-align: left;
`;
exports.StyledErrorYear = styled_components_1.default.small `
  position: absolute;
  bottom: -15px;
  color: ${({ theme }) => theme.error.main};
  opacity: 0.8;
  font-size: 11px;
  width: 100%;
`;
